export default "__VITE_ASSET__D3zJV6qh__"